/** @jsx jsx */
import { FC } from 'react';
import { jsx } from '@emotion/core';
import SimpleMessagePage from 'components/SimpleMessagePage';
import CancelButton from 'features/CancelButton';
import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';

const ValidationError: FC = () => {
  const tMdMultiline = useMarkdownMultilineTranslate();

  return (
    <SimpleMessagePage
      headerTitle={'existingAccount.validationRequired.error.title'}
      message={tMdMultiline(`existingAccount.validationRequired.error.message`)}
    >
      <CancelButton />
    </SimpleMessagePage>
  );
};

export default ValidationError;
